































import { Vue, Component } from "vue-property-decorator";
import { db, IVIPProduction, VIPProduction } from "@/loader";
import ProductionEdit from "../../component/production/ProductionEdit.vue";

@Component({
	components: {
		ProductionEdit,
	}
})
export default class Productions extends Vue {
	public production: VIPProduction | null = null;

	public get productions(): VIPProduction[] {
		return db.productions.list.sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
	}

	public select(production: VIPProduction | null) {
		this.production = production;
		this.$bvModal.show("prod_modal")
	}

	public create() {
		let i: number = 1;
		let data: IVIPProduction = {
			id: db.productions.list.nextNewId(),
			name: "Nouvelle Réalisation",
			slug: "nouvelle-realisation"
		};
		while (db.productions.list.find(p => p.slug === data.slug)) {
			data.name = `Nouvelle Réalisation ${++i}`;
			data.slug = data.name.kebabCase();
		}

		this.select(db.productions.insert(data));
	}
}
